import React, { useState } from 'react';

function PageHero({ title, sub }) {
  return (
    <div className="page-hero">
      <div className="page-hero-bg" />
      <div className="container">
        <span className="section-tag">Get In Touch</span>
        <h1 className="page-hero-title">{title}</h1>
        <p className="page-hero-sub">{sub}</p>
      </div>
    </div>
  );
}

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const clinicAddress = 'First Floor, SBI Building, Girdharganj Bazar, In front of AIIMS Gate No. 4, Gorakhpur - 273008';
  const mapQuery = encodeURIComponent(clinicAddress);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await new Promise(r => setTimeout(r, 1400));
    setLoading(false);
    setSubmitted(true);
  };

  return (
    <>
      <PageHero title={<>Book Your <em>Appointment</em></>} sub="Reach Dant Sanjeevani - Maxillofacial & Cleft Clinic directly, or send an appointment request and we will get back to you." />

      <section className="section">
        <div className="container">
          <div className="contact-layout">

            {/* Info column */}
            <div className="contact-info-col reveal">
              <div className="contact-info-card">
                <h3>Visit Our Clinic</h3>
                <div className="ci-item">
                  <span className="ci-icon">📍</span>
                  <div><strong>Address</strong><span>First Floor, SBI Building, Girdharganj Bazar,<br />In front of AIIMS Gate No. 4, Gorakhpur - 273008</span></div>
                </div>
                <div className="ci-item">
                  <span className="ci-icon">📞</span>
                  <div><strong>Phone</strong><a href="tel:+919044793270">+91 9044793270</a><br/><a href="tel:+9105513177523">0551-3177523</a></div>
                </div>
                <div className="ci-item">
                  <span className="ci-icon">✉️</span>
                  <div><strong>Email</strong><a href="mailto:dantsanjeevani@gmail.com">dantsanjeevani@gmail.com</a></div>
                </div>
                <div className="ci-item">
                  <span className="ci-icon">🕐</span>
                  <div>
                    <strong>Working Hours</strong>
                    <span>Please call to confirm consultation timings before visiting.</span>
                  </div>
                </div>
              </div>

              {/* Map placeholder */}
              <div className="map-placeholder reveal" style={{ '--delay': '0.15s' }}>
                <div className="map-inner">
                  <span className="map-pin">📍</span>
                  <span>Dant Sanjeevani<br />AIIMS Gate No. 4, Gorakhpur</span>
                  <a href={`https://maps.google.com/?q=${mapQuery}`} target="_blank" rel="noreferrer" className="btn-ghost map-btn">Open in Maps →</a>
                </div>
              </div>
            </div>

            {/* Form column */}
            <div className="contact-form-col reveal" style={{ '--delay': '0.2s' }}>
              <div className="form-wrap">
                {!submitted ? (
                  <>
                    <div className="form-heading">
                      <h2>Request an Appointment</h2>
                      <p>Share your details and we will contact you to confirm a suitable consultation slot.</p>
                    </div>
                    <form onSubmit={handleSubmit}>
                      <div className="form-row">
                        <div className="form-group"><label htmlFor="fName">First Name *</label><input id="fName" type="text" placeholder="Sangeeta" required /></div>
                        <div className="form-group"><label htmlFor="lName">Last Name *</label><input id="lName" type="text" placeholder="Arvind" required /></div>
                      </div>
                      <div className="form-row">
                        <div className="form-group"><label htmlFor="cemail">Email *</label><input id="cemail" type="email" placeholder="you@example.com" required /></div>
                        <div className="form-group"><label htmlFor="phone">Phone *</label><input id="phone" type="tel" placeholder="+91 90447 93270" required /></div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="doctor">Preferred Doctor</label>
                        <select id="doctor">
                          <option value="">Any available doctor</option>
                          <option>Dr. Sangeeta Arvind - Oral Surgery, Implantology, Cleft Care</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="service">Service Required</label>
                        <select id="service">
                          <option value="">Select a service…</option>
                          {['Routine Dental Check-up','Scaling & Polishing','Root Canal Treatment','Dental Bridges & Crown','Dental Implants','Teeth Whitening','Cosmetic Dentistry','Porcelain Veneers','Gum Disease Treatment','Laser Dentistry','Cleft Surgery','TMJ Treatment','Fracture of Jaw Treatment','3D Guided Implant Surgery','Other'].map(s => <option key={s}>{s}</option>)}
                        </select>
                      </div>
                      <div className="form-row">
                        <div className="form-group"><label htmlFor="date">Preferred Date</label><input id="date" type="date" /></div>
                        <div className="form-group">
                          <label htmlFor="time">Preferred Time</label>
                          <select id="time">
                            <option>Morning</option>
                            <option>Afternoon</option>
                            <option>Evening</option>
                          </select>
                        </div>
                      </div>
                      <div className="form-group"><label htmlFor="notes">Additional Notes</label><textarea id="notes" rows="3" placeholder="Share your concern, symptoms, or any treatment history that may help before the visit." /></div>
                      <button type="submit" className="btn-primary btn-full" disabled={loading}>
                        <span>{loading ? 'Submitting…' : 'Confirm Appointment Request'}</span>
                        {!loading && <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>}
                      </button>
                      <p className="form-note">* Required fields. We never share your data.</p>
                    </form>
                  </>
                ) : (
                  <div className="form-success">
                    <div className="success-icon">✓</div>
                    <h3>Appointment Requested!</h3>
                    <p>Thank you. Your request has been noted and the clinic will contact you to confirm the appointment.</p>
                    <button className="btn-ghost" style={{ marginTop: '20px' }} onClick={() => setSubmitted(false)}>Book Another →</button>
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Emergency banner */}
      <section className="section" style={{ paddingTop: 0 }}>
        <div className="container">
          <div className="emergency-banner reveal">
            <div className="eb-left">
              <span className="eb-icon">🚨</span>
              <div>
                <h3>Dental Emergency?</h3>
                <p>For urgent care, call the clinic directly for the fastest response.</p>
              </div>
            </div>
            <a href="tel:+919044793270" className="btn-primary">Call Now: +91 9044793270</a>
            <a href="tel:+9105513177523" className="btn-primary" style={{marginLeft:'12px'}}>Landline: 0551-3177523</a>
          </div>
        </div>
      </section>
    </>
  );
}
